module.exports = __webpack_public_path__ + "4d26ef90ae2cef894073eafc2f971c18.jpg";